"use client";

import { useEffect, useRef, useState } from "react";

export function useTimedState<T>(initial: T, duration: number) {
  const [value, setValue] = useState(initial);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clear = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  useEffect(() => () => clearTimeout(timeoutRef.current ?? undefined), []);

  const set = (next: T) => {
    setValue(next);
    clear();
    timeoutRef.current = setTimeout(() => setValue(initial), duration);
  };

  const reset = () => {
    clear();
    setValue(initial);
  };

  return [value, set, reset] as const;
}
